import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty, cloneDeep } from 'lodash';

import {
  createNewSpark,
  getSparks,
  getSpark,
  postSpark,
  patchSpark,
  putAdditionalFuns,
  getSparksFromGrid
} from '../common/actions/sparks';
import { getFilterStr, getMediaForUIName, getInternalBaseUrl } from '../common/global';
import {
  getChallengesBySparkId,
  postChallenge,
  postChallenges,
  patchChallenge,
} from '../common/actions/challenges';
import { getCluesBySparkId, postClue, postClues, patchClue } from '../common/actions/clues';
import { uploadMedia } from '../common/actions/medias';

import SparkList from '../molecules/sparks/SparkList';
import * as constants from '../common/constants';
import styles from './SparksPage.module.scss';
import SparkDetails from '../molecules/sparks/SparkDetails';
import SparkOthers from '../molecules/sparks/SparkOthers';
import { SparkManagerProvider } from '../molecules/sparks/ManagerContext';
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { Box } from '@material-ui/core';
import moment from 'moment';
import * as wpsdb from '../molecules/sparks/wipdb.json';

class SparksPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      searchText: '',
      mode: 'list',
      masterTags: wpsdb.Tags,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    const { isRefreshRequired = false } = this.props;

    if (isRefreshRequired === true && prevProps.isRefreshRequired !== isRefreshRequired) {
      this.loadData();
    }
  }

  loadData() {
    const {
      id = '',
      newSparkId,
      getSparksFunc,
      getSparkFunc,
      getChallengesBySparkIdFunc,
      getCluesBySparkIdFunc,
    } = this.props;

    const sparkId = !isEmpty(id) ? id : newSparkId;

    getSparksFunc();
    if (isEmpty(sparkId)) return;

    getSparkFunc(sparkId);
    getChallengesBySparkIdFunc(sparkId);
    getCluesBySparkIdFunc(sparkId);
  }

  setUnsavedDataFlag(unsavedData) {
    if (!isEmpty(unsavedData)) this.props.setUnsavedDataFlagFunc(true);
  }

  onChangeSearchText = (searchText) => {
    const { filter = {}, getSparksFunc } = this.props;
    let filterStr = getFilterStr(filter);
    filterStr += '&query=' + searchText;

    getSparksFunc(filterStr);

    this.setState({
      searchText,
    });
  };

  onSelectSpark = (id) => {
    const { getSparkFunc, getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    getSparkFunc(id);
    getChallengesBySparkIdFunc(id);
    getCluesBySparkIdFunc(id);
    this.setState({
      mode: 'edit',
    });
  };

  onCreateSpark = () => {
    const { createNewSparkFunc } = this.props;
    createNewSparkFunc();
    this.setState({
      mode: 'add',
    });
  };

  onSaveSpark = (spark) => {
    if (isEmpty(spark)) return null;
    const { postSparkFunc, patchSparkFunc } = this.props;

    if (spark.id) {
      patchSparkFunc(spark);
    } else {
      postSparkFunc(spark);
    }
  };

  onCopySpark = async (spark) => {
    if (isEmpty(spark)) return null;
    const { challenges = [], clues = [], postSparkSuccess, postSparkError } = this.props;
    const response = await postSpark(spark, true);
    if (!response || response.error) {
      postSparkError(response.error);
    }
    const newSparkId = response.data;

    const newChallegeArray = [];
    challenges.forEach((challenge) => {
      const newChallenge = cloneDeep(challenge);
      newChallenge.sparkId = newSparkId;
      newChallenge.name = `Copy of ${challenge.name}`;
      delete newChallenge.id;
      newChallegeArray.push(newChallenge);
    });
    const challengeRes = await postChallenges(newChallegeArray);

    const newClueArray = [];
    clues.forEach((clue) => {
      const newClue = cloneDeep(clue);
      newClue.sparkId = newSparkId;
      newClue.name = `Copy of ${clue.name}`;
      delete newClue.id;
      newClueArray.push(newClue);
    });
    const clueRes = await postClues(newClueArray);

    if (!challengeRes.data || challengeRes.error || !clueRes.data || clueRes.error) {
      postSparkError(challengeRes.error ? challengeRes.error : clueRes.error);
    }
    let gotToSparkUrl = getInternalBaseUrl().sparks + '?id=' + newSparkId;
    this.props.history.push(gotToSparkUrl);
    setTimeout(() => {
      postSparkSuccess(response);
    }, 800);
  };

  onSaveChallenge = (challenge) => {
    if (isEmpty(challenge)) return null;
    if (challenge.id) {
      const { patchChallengeFunc } = this.props;
      patchChallengeFunc(challenge);
    } else {
      const { spark = {}, postChallengeFunc } = this.props;
      challenge.sparkId = spark.id;
      postChallengeFunc(challenge);
    }
  };

   handleFiltersChange=(params)=>{
    const {getSparksFunc } = this.props;
    const filters = params.items;
    let newParams=''
    for (const filter of filters) {
      let value = filter.value;
      newParams += `${filter.columnField}:${filter.operatorValue}:${value}`;
      const { getSparksFromGridFunc } = this.props;
      // Make API call with filterModel as parameters
      if(['isEmpty','isNotEmpty'].includes(filter.operatorValue)){
        getSparksFromGridFunc(newParams);
      }else{
        if(filter.value){
          getSparksFromGridFunc(newParams);
        }   
      }
    }
    if(!filters.length){
      getSparksFunc();
    }
   }

  onSaveClue = (clue) => {
    if (isEmpty(clue)) return null;
    if (clue.id) {
      this.props.patchClueFunc(clue);
    } else {
      const { spark = {}, postClueFunc } = this.props;

      clue.sparkId = spark.id;
      postClueFunc(clue);
    }
  };

  onSaveAdditionalFuns = (additionalFuns) => {
    additionalFuns.forEach((af) => {
      delete af.index;
    });

    const { spark = {}, putAdditionalFunsFunc } = this.props;
    putAdditionalFunsFunc(spark.id, additionalFuns);
  };

  renderSparkList() {
      const { sparks, spark, id, newSparkId } = this.props;
      const sparkId = !isEmpty(id) ? id : newSparkId;
      const mode = this.state.mode;
      const masterTags = this.state.masterTags;
      const capitalizeFirst = str => {        
        return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
      };
      const columns = [ 
        { 
          field: 'name', 
          headerName: 'Spark Name', 
          renderCell: (params) => {
            return (<a href={'/sparks?id=' + params.id} target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline', color: 'black'}}>{params.value}</a>);
          },
          width: '300',
          editable: false 
        }, 
        { 
          field: 'status', 
          headerName: 'Status', 
          valueFormatter: (params) => {
            return capitalizeFirst(params.value);
          },
          width: '150',
          editable: false 
        },    
        { 
          field: 'category', 
          headerName: 'Category', 
          valueFormatter: (params) => {
            return capitalizeFirst(params.value);
          },
          width: '150',
          editable: false 
        },   
        {
          field: 'private',
          headerName: 'Internal Summary',
          valueGetter: (params) => {
            return params?.row?.note?.private || '';
          },
          width: '200',
          editable: false,
        },
        {
            field: 'tagsInterests',
            headerName: 'Interests',
            editable: false,
            renderCell: (params) => {
                const tagIdList = [].concat(
                    (params.row?.tags?.['Interests'] || []).map((tagId) => masterTags['Interests'][tagId-1]?.name || '-')
                );
                return tagIdList.join(', ');
            },
            valueGetter: (params) => {
              const tagIdList = [].concat(
                    (params.row?.tags?.['Interests'] || []).map((tagId) => masterTags['Interests'][tagId-1]?.name || '-')
                );
                return tagIdList.join(', ');
            },
            width: '200',
        },
        {
            field: 'tagsOccassion',
            headerName: 'Occassion',
            editable: false,
            renderCell: (params) => {
                const tagIdList = [].concat(
                    (params.row?.tags?.['Occasion'] || []).map((tagId) => masterTags['Occasion'][tagId-1]?.name || '-')
                );
                return tagIdList.join(', ');
            },
            valueGetter: (params) => {
              const tagIdList = [].concat(
                    (params.row?.tags?.['Occasion'] || []).map((tagId) => masterTags['Occasion'][tagId-1]?.name || '-')
                );
                return tagIdList.join(', ');
            },
            width: '200',
        },
        {
            field: 'tagsParticipant',
            headerName: 'Participant',
            editable: false,
            renderCell: (params) => {
                const tagIdList = [].concat(
                    (params.row?.tags?.['Participant'] || []).map((tagId) => masterTags['Participant'][tagId-1]?.name || '-')
                );
                return tagIdList.join(', ');
            },
            valueGetter: (params) => {
              const tagIdList = [].concat(
                    (params.row?.tags?.['Participant'] || []).map((tagId) => masterTags['Participant'][tagId-1]?.name || '-')
                );
                return tagIdList.join(', ');
            },
            width: '200',
        },
        {
          field: 'createdDateTime',
          type: 'date',
          headerName: 'Created Date',
          valueFormatter: (params) => {
              return moment(params.value).format('DD MMM YY');
          },
          editable: false,
          width: '150',
      },
      {
        field: 'updatedDateTime',
        type: 'date',
        headerName: 'Updated Date',
        valueFormatter: (params) => {
            return moment(params.value).format('DD MMM YY');
        },
        editable: false,
        width: '150',
      }, 
      { 
        field: 'id', 
        headerName: 'Spark Id',
        width: '250', 
        editable: false 
      },
    ];
      return (
        <>
        <div className={styles.left} key="sparkList">
          <SparkList
            sparks={sparks}
            spark={spark}
            onSelectSparkFunc={this.onSelectSpark}
            onCreateSparkFunc={this.onCreateSpark}
            onChangeSearchTextFunc={this.onChangeSearchText}
          />
        </div>
        {isEmpty(sparkId) && mode==='list' && <DataGrid
                  style={{ flex: 1, margin: 20 }}
                  rows={sparks}
                  columns={columns}
                  pageSize={100}
                  sx={{ overflowX: 'scroll' }}
                  filterMode="server"
                  onFilterModelChange={this.handleFiltersChange}
                  components={{ Toolbar: this.DataGridToolbar }}
                  
        />}
        </>
      );    
    }

    DataGridToolbar(props) {
      return (
          <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
              <GridToolbarContainer style={{ paddingTop: '10px' }}>
                  <GridToolbarColumnsButton style={{ color: '#434F69' }} />
                  <GridToolbarFilterButton style={{ color: '#434F69' }} />
                  <GridToolbarExport style={{ color: '#434F69' }} />
              </GridToolbarContainer>
          </Box>
      );
  }

  renderSparksDetails() {
    const { spark, sparkMedia, uploadMediaFunc, id, newSparkId } = this.props;
    const sparkId = !isEmpty(id) ? id : newSparkId;
    const mode = this.state.mode;
    if (isEmpty(spark) || (isEmpty(sparkId) && mode==='list')) return <div />;
    return (
      <div className={styles.center}>
        <SparkManagerProvider>
        <SparkDetails
          spark={spark}
          media={sparkMedia}
          onSaveSparkFunc={this.onSaveSpark}
          onCopySparkFunc={this.onCopySpark}
          uploadMediaFunc={uploadMediaFunc}
        />
        </SparkManagerProvider>
      </div>
    );
  }

  renderSparkOthers() {
    const {
      challenges = [],
      clues = [],
      spark = {},
      challengeMedia,
      clueMedia,
      uploadMediaFunc,
      additionalFunMedia,
      newSparkId 
    } = this.props;
    const sparkId = !isEmpty(this.props.id) ? this.props.id : newSparkId;    
    const { additionalFuns = [], id = '-1' } = spark;
    if (id === '-1' || isEmpty(sparkId)) return <div />;
    return (
      <div className={styles.right}>
        <SparkOthers
          challenges={challenges}
          challengeMedia={challengeMedia}
          additionalFuns={additionalFuns}
          additionalFunMedia={additionalFunMedia}
          clues={clues}
          clueMedia={clueMedia}
          onSaveChallengeFunc={this.onSaveChallenge}
          onSaveClueFunc={this.onSaveClue}
          onSaveAdditionalFunsFunc={this.onSaveAdditionalFuns}
          uploadMediaFunc={uploadMediaFunc}
          spark={spark}
        />
      </div>
    );
  }

  render() {
    let components = [];
    components.push(this.renderSparkList());
    components.push(this.renderSparksDetails());
    components.push(this.renderSparkOthers());
    return <div className={styles.root}>{components}</div>;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createNewSparkFunc: () => dispatch(createNewSpark()),

    getSparksFunc: (filterParams) => dispatch(getSparks(filterParams)),
    getSparksFromGridFunc: (filterParams) => dispatch(getSparksFromGrid(filterParams)),
    getSparkFunc: (id) => dispatch(getSpark(id)),

    getChallengesBySparkIdFunc: (sparkId) => dispatch(getChallengesBySparkId(sparkId)),
    getCluesBySparkIdFunc: (sparkId) => dispatch(getCluesBySparkId(sparkId)),

    postSparkFunc: (spark) => dispatch(postSpark(spark)),
    postChallengeFunc: (challenge) => dispatch(postChallenge(challenge)),
    postClueFunc: (clue) => dispatch(postClue(clue)),

    patchSparkFunc: (spark) => dispatch(patchSpark(spark)),
    patchChallengeFunc: (challenge) => dispatch(patchChallenge(challenge)),
    patchClueFunc: (clue) => dispatch(patchClue(clue)),

    putAdditionalFunsFunc: (sparkId, additionalFuns) =>
      dispatch(putAdditionalFuns(sparkId, additionalFuns)),

    postSparkSuccess: (spark) => {
      dispatch({
        type: constants.POST_SPARK_SUCCESS,
        spark: spark,
      });
    },

    postSparkError: (error) => {
      dispatch({
        type: constants.POST_SPARK_ERROR,
        error,
      });
    },

    uploadMediaFunc: (mediaFor, mediaType, file) =>
      dispatch(uploadMedia(mediaFor, mediaType, file)),
  };
};

const mapStateToProps = (state) => {
  const stateSparks = state.sparks || {};
  const stateChallenges = state.challenges || {};
  const stateClues = state.clues || {};
  const stateMedias = state.medias || {};

  const { sparks = [], spark = {}, error = {}, newSparkId } = stateSparks;
  const { media = {} } = stateMedias;
  const { ui = '' } = media;

  const { challenges = [] } = stateChallenges;

  let isRefreshRequired = false;
  isRefreshRequired =
    stateSparks.isRefreshRequired === true ||
    stateChallenges.isRefreshRequired === true ||
    stateClues.isRefreshRequired === true;

  const sparkMedia = ui === getMediaForUIName().spark ? media : {};
  const challengeMedia = ui === getMediaForUIName().challenge ? media : {};
  const clueMedia = ui === getMediaForUIName().clue ? media : {};
  const additionalFunMedia = ui === getMediaForUIName().additionalFun ? media : {};

  // TODO: Clean clues reducer
  const { clues = [] } = stateClues;

  // TODO: introduce a way to throw error in case of failure
  if (!isEmpty(error)) {
    console.log(error.message);
  }

  return {
    isRefreshRequired,
    sparks,
    spark,
    challenges,
    clues,
    newSparkId,
    sparkMedia,
    challengeMedia,
    clueMedia,
    additionalFunMedia,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SparksPage));
